"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledLabel = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
const config_1 = require("assets/styles/config");
exports.StyledLabel = styled_components_1.default.label `
  font: 500 ${config_1.fontSizes.base} ${config_1.fontFamilies.primary};
  margin-top: ${(props) => (props.spacing ? props.spacing : '0')};
`;
